// Browser chrome follows the theme, never an individual album or scroll position.
// Keeping the document canvas stable avoids a cross-fade when returning to another route.
export function syncBrowserThemeColor() {
  const color = document.documentElement.dataset.theme === 'dark' ? '#11100f' : '#ffffff';
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.removeAttribute('media');
  meta.content = color;
}
